// extracted by mini-css-extract-plugin
module.exports = {"link":"StoryboardLink_link__nP3P_","link-wrap":"StoryboardLink_link-wrap__EEhpt"};